export const CULTIVO_TIPO_IDS = [1, 2]

export const CULTIVOS = {
  SUELO: 1,
  MACETA: 2,
}
